import React, { useRef, useEffect, useState } from "react";
import Images from "../images";
import LazyImg from "./LazyImg";
import { Link } from "react-router-dom";

const BuildingKnowledgeCommunity = () => {
  // ✅ useState instead of React.useState
  const [loading, setLoading] = useState(true);

  // ✅ useEffect instead of React.useEffect
  useEffect(() => {
    const timer = setTimeout(() => {
      setLoading(false);
    }, 300); // loader disappears after 2s

    return () => clearTimeout(timer);
  }, []);
  const faqs = [
    {
      question:
        "What is the process if one wants to participate in knowledge exchange sharing activities conducted under the MedEngage programme?",
      answer: (
        <>
          To participate in the Knowledge Exchange Programme and to be part of
          MedTalk, one must be part of the MedEngage universe. For this, please
          log on to the MedEngage website and register to participate in
          MedTalk, Quiz, and other activities under the MedEngage programme. You
          may also write to us at{" "}
          <a href="mailto:support@med-engage.com" className="text-success">
            support@med-engage.com
          </a>{" "}
          or{" "}
          <a
            href="mailto:shalini.sahay@metropolisindia.com"
            className="text-success"
          >
            shalini.sahay@metropolisindia.com
          </a>{" "}
          or{" "}
          <a
            href="mailto:jeyasingh.b@metropolisindia.com"
            className="text-success"
          >
            jeyasingh.b@metropolisindia.com
          </a>
        </>
      ),
    },
    {
      question:
        "What steps do I need to follow to participate in the MedTalk (offline) program?",
      answer: (
        <>
          To be part of the MedTalk (offline), you will need to share one photo
          and your biodata with the CSR team at{" "}
          <a
            href="mailto:academics.sciencecell@metropolisindia.com"
            className="text-success"
          >
            academics.sciencecell@metropolisindia.com
          </a>{" "}
          or{" "}
          <a
            href="mailto:shalini.sahay@metropolisindia.com"
            className="text-success"
          >
            shalini.sahay@metropolisindia.com
          </a>{" "}
          (9310554590) or{" "}
          <a
            href="mailto:jeyasingh.b@metropolisindia.com"
            className="text-success"
          >
            jeyasingh.b@metropolisindia.com
          </a>{" "}
          (8928286168).
        </>
      ),
    },
    {
      question:
        "Will I get a chance to interact with senior doctors and ask questions?",
      answer: "Yes",
    },
    {
      question: "Will MedTalks be shared on social media?",
      answer: "Yes",
    },
    {
      question:
        "  Is it possible for Metropolis Healthcare to organize Continuing Medical Education (CME) sessions on demand for interested participants ?",
      answer: "Yes",
    },
    {
      question:
        "Is there any cost involved if one wants to participate in Med talk, Quiz and participate in scientific exchange of information ?",
      answer: "No, Its free of cost",
    },
    {
      question: "Will there be any certificates awarded for participation ?",
      answer:
        "No, however, we will display and disseminate the MedTalk through social media.",
    },
    {
      question: "Who can participate in MedTalk sessions and webinars?",
      answer: (
        <>
          MedTalk sessions and webinars are open to all members of the MedEngage
          universe, including medical students, healthcare professionals, and
          faculty. To participate, you must register on the MedEngage platform
          and complete the required registration process for the specific
          activity. For any queries, you may contact{" "}
          <span className="text-success">support@med-engage.com</span> or{" "}
          <span className="text-success">
            shalini.sahay@metropolisindia.com
          </span>{" "}
          or{" "}
          <span className="text-success">jeyasingh.b@metropolisindia.com</span>
          .
        </>
      ),
    },
  ];
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  const [openIndex, setOpenIndex] = useState(null);

  const toggleFAQ = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };
  const [hoveredCard, setHoveredCard] = useState(null);

  const contacts = [
    {
      id: 1,
      title: "Registration & Application",
      email: "application@med-engage.com",
      gradient: "lightblue",
      icon: "📋",
      description: "Start your medical journey with us",
    },
    {
      id: 2,
      title: "Support & Contact",
      email: "support@med-engage.com",
      gradient: "lightgreen",
      icon: "🚀",
      description: "Get help when you need it",
    },
    {
      id: 3,
      title: "Academics",
      email: "academics.sciencecell@metropolisindia.com",
      gradient: "lightpink",
      icon: "🎯",
      description: "Academic excellence support",
    },
  ];

  const teamMembers = [
    {
      id: 1,
      name: "Shalini Sahay",
      email: "shalini.sahay@metropolisindia.com",
      phone: "+91 9310554590",
      gradient: "lightcoral",
      avatar: "SS",
      role: "Team Lead",
    },
    {
      id: 2,
      name: "Jeyasingh B",
      email: "jeyasingh.b@metropolisindia.com",
      phone: "+91 8928286168",
      gradient: "lightseagreen",
      avatar: "JB",
      role: "Secondary Contact",
    },
  ];
  useEffect(() => {
    document.title = "Building Knowledge Community - MedEngage";
  }, []);

  return (
    <>
      {loading && (
        <div
          className="fixed-top w-100 h-100 d-flex justify-content-center align-items-center bg-dark bg-opacity-50"
          style={{ zIndex: 9999 }}
        >
          <div className="custom-spinner"></div>
        </div>
      )}
      <div>
        <section className="ul-breadcrumb ul-section-spacing">
          <div className="ul-container">
            <h2 className="ul-breadcrumb-title">
              Building Knowledge Community
            </h2>
            <ul className="ul-breadcrumb-nav">
              <li>
                <Link to="/">Home</Link>
              </li>

              <li>
                <span className="separator">
                 <i className="fa fa-arrow-right"></i>
                </span>
              </li>
              <li>Building Knowledge Community</li>
            </ul>
          </div>
        </section>

        <section className="ul-about ul-section-spacing ">
          <div className="ul-container">
            <div className="row row-cols-md-2 row-cols-1 align-items-center gy-4 ul-about-row">
              <div className="col">
                <div className="ul-about-txt">
                  <h2 className="ul-section-title">
                    MedTalk{" "}
                    <span>
                      <strong className="green">
                        {" "}
                        & Intergenerational Learning{" "}
                      </strong>
                    </span>
                  </h2>

                  <p className="ul-section-descr">
                    Metropolis Healthcare Limited and Metropolis Foundation
                    promote a learning culture aligned with their ethos of{" "}
                    <strong>Educate, Empower, and Encourage</strong>. In the
                    same line, MedTalk sessions and webinars are planned under
                    CSR to strengthen and enhance the knowledge base and promote
                    a learning culture.
                  </p>

                  <p className="ul-section-descr">
                    MedTalk sessions are intergenerational dialogues and
                    exchanges of scientific information within the MedEngage
                    universe. They are interactive engagement sessions led by
                    experienced, seasoned doctors and young, dynamic doctors to
                    overcome cross-generational barriers and co-create a
                    futuristic healthcare vision.
                  </p>

                  <p className="ul-section-descr">
                    These sessions provide an opportunity for medical students
                    to learn directly from experts, expand their horizons, and
                    gain a 360-degree perspective on healthcare—yesterday,
                    today, and tomorrow.
                  </p>
                </div>
              </div>

              <div className="col">
                <div className="ul-about-imgs">
                  <div className="img-wrapper text-center">
                    <LazyImg
                      src={Images.Medtalk1}
                      alt="MedTalk episode thumbnail featuring Dr Shirish Hasthak"
                      className="scholarship-image rounded-3"
                    />
                    <div className="img-caption mt-2">
                      MedTalk Episode with Dr Shirish Hasthak – MD Medicine, DM
                      Neurology (Stroke), Fellowship UWO, Canada along with
                      MedEngage winner – Dr Keyur Sabnis. The MedTalk was
                      moderated by Dr Kirti Chadha – Chief Scientific &
                      Innovation Officer and Group Head – CSR.
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="stats-section">
          <div className="container">
            <h2 className="ul-section-title text-white text-center">
              Objective of MedTalk{" "}
            </h2>
            <div className="stats-grid">
              <div className="stat-card">
                <div className="stat-number">1</div>
                <div className="stat-label">
                  <span className="text-dark">
                    A learning interactive platform where medical students learn
                    and discuss specific themes and specialities, build a
                    learning culture and expand doctors' horizons.
                  </span>
                </div>
              </div>
              <div className="stat-card">
                <div className="stat-number">2</div>
                <div className="stat-label">
                  <span className="text-dark">
                    Build a MedEngage universe that exists only to show and
                    nurture young medical talent.
                  </span>
                </div>
              </div>
              <div className="stat-card">
                <div className="stat-number">3</div>
                <div className="stat-label">
                  <span className="text-dark">
                    Allow all beneficiaries of the MedEngage CSR program a
                    linear trajectory of impact
                  </span>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* MEDTALKS & WEBINARS SECTION START */}
        <div className="ul-section-spacing">
          <div className="ul-container">
            <div className="ul-donate-form-section">
              <div className="row justify-content-center align-items-center">
                <div className="col-lg-12 text-white text-center">
                  <h3 className="mb-4">MedTalks & Webinars</h3>
                  <div className="row g-1 justify-content-center">
                    {/* MedTalk 1 */}
                    <div className="col-sm-6 col-md-4">
                      <div className="speaker-card text-light h-100 p-3 rounded-3">
                        <div className="position-relative mb-3">
                          <a
                            href="https://www.youtube.com/live/TxrmoqaXGBw?si=MTXAVMJY29WwVMdg"
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            <LazyImg
                              src="https://img.youtube.com/vi/TxrmoqaXGBw/hqdefault.jpg"
                              alt="MedTalk video thumbnail - Dr. Shirish, Dr. Kirti & Dr. Keyur"
                              className="img-fluid rounded-top thumbnail"
                            />
                            <div className="video-play-icon medtalk-video-play-icon">
                              <i className="fa fa-play text-dark fs-6"></i>
                            </div>
                          </a>
                        </div>
                        <h6 className="text-light semi">
                          Dr. Shirish, Dr. Kirti & Dr. Keyur
                        </h6>
                        <p className="thumb-p text-light mb-0">
                          MedTalk by Metropolis MedEngage - Career Conversations
                          by, for & with doctors
                        </p>
                      </div>
                    </div>

                    {/* MedTalk 2 */}
                    <div className="col-sm-6 col-md-4">
                      <div className="speaker-card text-light h-100 p-3 rounded-3">
                        <div className="position-relative mb-3">
                          <a
                            href="https://www.youtube.com/live/Qz1ZcuWKcRc?si=p-qmtSw2vZgvOjhM"
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            <LazyImg
                              src="https://img.youtube.com/vi/Qz1ZcuWKcRc/hqdefault.jpg"
                              alt="MedTalk video thumbnail - Dr. Prateek, Dr. Kirti & Dr. Akatya"
                              className="img-fluid rounded-top thumbnail"
                            />
                            <div className="video-play-icon medtalk-video-play-icon">
                              <i className="fa fa-play text-dark fs-6"></i>
                            </div>
                          </a>
                        </div>
                        <h6 className="text-light semi">
                          Dr. Prateek, Dr. Kirti & Dr. Akatya
                        </h6>
                        <p className="thumb-p text-light mb-0">
                          MedTalk by Metropolis MedEngage - Career Conversations
                          by, for & with doctors
                        </p>
                      </div>
                    </div>

                    {/* Webinar 1 */}
                    <div className="col-sm-6 col-md-4">
                      <div className="speaker-card text-light h-100 p-3 rounded-3">
                        <div className="position-relative mb-3">
                          <a
                            href="https://www.youtube.com/live/dIobteowbu0?si=pc4-Mx3w8EwT1QXl"
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            <LazyImg
                              src="https://img.youtube.com/vi/dIobteowbu0/hqdefault.jpg"
                              alt="MedTalk video thumbnail - Dr. Sheila & Dr. Madhura"
                              className="img-fluid rounded-top thumbnail"
                            />
                            <div className="video-play-icon medtalk-video-play-icon">
                              <i className="fa fa-play text-dark fs-6"></i>
                            </div>
                          </a>
                        </div>
                        <h6 className="text-light semi">
                          Dr. Sheila & Dr. Madhura
                        </h6>
                        <p className="thumb-p text-light mb-0">
                          MedTalk with key opinion leader & subject matter
                          experts of various clinical specialties
                        </p>
                      </div>
                    </div>

                    {/* Webinar 2 */}
                    <div className="col-sm-6 col-md-4">
                      <div className="speaker-card text-light h-100 p-3 rounded-3">
                        <div className="position-relative mb-3">
                          <a
                            href="https://www.youtube.com/live/hk5rHMw_Grw?si=_9iHOHMPj1M4aRHa"
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            <LazyImg
                              src="https://img.youtube.com/vi/hk5rHMw_Grw/hqdefault.jpg"
                              alt="MedTalk video thumbnail - Dr. Priya & Dr. Ali"
                              className="img-fluid rounded-top thumbnail"
                            />
                            <div className="video-play-icon medtalk-video-play-icon">
                              <i className="fa fa-play text-dark fs-6"></i>
                            </div>
                          </a>
                        </div>
                        <h6 className="text-light semi">Dr. Priya & Dr. Ali</h6>
                        <p className="thumb-p text-light mb-0">
                          MedTalk with key opinion leader & subject matter
                          experts of various clinical specialties
                        </p>
                      </div>
                    </div>

                    {/* Webinar 3 */}
                    <div className="col-sm-6 col-md-4">
                      <div className="speaker-card text-light h-100 p-3 rounded-3">
                        <div className="position-relative mb-3">
                          <a
                            href="https://www.youtube.com/live/TcFs2ezuJ8k?si=5WPStTpTehhv8UEy"
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            <LazyImg
                              src="https://img.youtube.com/vi/TcFs2ezuJ8k/hqdefault.jpg"
                              alt="MedTalk video thumbnail - Dr. Shreyansh & Dr. Nilanji"
                              className="img-fluid rounded-top thumbnail"
                            />
                            <div className="video-play-icon medtalk-video-play-icon">
                              <i className="fa fa-play text-dark fs-6"></i>
                            </div>
                          </a>
                        </div>
                        <h6 className="text-light semi">
                          Dr. Shreyansh & Dr. Nilanji
                        </h6>
                        <p className="thumb-p text-light mb-0">
                          MedTalk with key opinion leader & subject matter
                          experts of various clinical specialties
                        </p>
                      </div>
                    </div>

                    {/* Webinar 4 */}
                    <div className="col-sm-6 col-md-4">
                      <div className="speaker-card text-light h-100 p-3 rounded-3">
                        <div className="position-relative mb-3">
                          <a
                            href="https://www.youtube.com/live/oq6VJ7STnkA?si=PqdSti-enndqzfvg"
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            <LazyImg
                              src="https://img.youtube.com/vi/oq6VJ7STnkA/hqdefault.jpg"
                              alt="MedTalk video thumbnail - Dr. Radhyashyam & Dr. Vani"
                              className="img-fluid rounded-top thumbnail"
                            />
                            <div className="video-play-icon medtalk-video-play-icon">
                              <i className="fa fa-play text-dark fs-6"></i>
                            </div>
                          </a>
                        </div>
                        <h6 className="text-light semi">
                          Dr. Radhyashyam & Dr. Vani
                        </h6>
                        <p className="thumb-p text-light mb-0">
                          MedTalk with key opinion leader & subject matter
                          experts of various clinical specialties
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* MEDTALKS & WEBINARS SECTION END */}

        <section className="ul-about ul-section-spacing ">
          <div className="ul-container">
            <div className="row row-cols-md-2 row-cols-1 align-items-center gy-4 ul-about-row">
              <div className="col">
                <div className="ul-about-imgs">
                  <div className="img-wrapper text-center">
                    <LazyImg
                      src={Images.Medtalk2}
                      alt="MedTalk episode thumbnail"
                      className="scholarship-image rounded-3"
                    />
                    <div className="img-caption mt-2">
                      MedTalk Episode with Dr (Capt.) Prateek Kinra – Human
                      Resources Principal Director at Government of India
                      Official and Dr Sinha – MedEngage winner. The MedTalk was
                      moderated by Dr Kirti Chadha – Chief Scientific &
                      Innovation Officer and Group Head – CSR.
                    </div>
                  </div>
                </div>
              </div>
              <div className="col">
                <div className="ul-about-txt">
                  <h3 className="ul-section-title text-center">
                    How MedTalk
                    <span className="version green p-1">
                      will be conducted?
                    </span>
                  </h3>

                  <p className="ul-section-descr">
                    Med Talk will be conducted both Online and Offline. The
                    participating doctors will get exposure to both
                    International and Indian doctors – successful and in the
                    making
                  </p>

                  <p className="ul-section-descr">
                    The initiative also encourages and promotes the conduction
                    of quizzes and the exchange of scientific exchange of
                    information at frequent intervals among the MedEngage
                    universe. These exchanges help to enhance skills and update
                    knowledge.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="faq-section">
          <div className="ul-container">
            <h2 className="ul-section-title text-center p-2 m-2">FAQs</h2>
            <div className="faq-container">
              <div className="faq-grid">
                {faqs.map((faq, index) => (
                  <div
                    key={index}
                    className="faq-item"
                    onClick={() => toggleFAQ(index)}
                  >
                    <div style={{ flex: 1 }}>
                      <span className="faq-question">{faq.question}</span>
                      <div
                        className={`faq-answer ${
                          openIndex === index ? "show" : ""
                        }`}
                        onClick={(e) => e.stopPropagation()} // prevents closing when clicking inside
                      >
                        {faq.answer}
                      </div>
                    </div>
                    <span className="faq-icon">
                      <LazyImg
                        src={openIndex === index ? Images.Minus : Images.Plus}
                        alt={openIndex === index ? "Collapse" : "Expand"}
                        className="faq-toggle-icon"
                      />
                    </span>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </section>

        <section className="med-cards-section py-4 py-md-5">
          <div className="container-fluid px-3 px-md-5">
            {/* Department Contacts */}
            <div className="row g-2 g-md-2 mb-3 mb-md-5 justify-content-center">
              <div className="col-12 text-center mb-1 mb-md-4">
                <h2 className="fw-bold">
                  <span className="text-success">Contact</span> Information
                </h2>
                <div className="divider mx-auto"></div>
              </div>
              {contacts.map((contact, index) => (
                <div
                  key={contact.id}
                  className="col-12 col-sm-6 col-lg-4 d-flex"
                >
                  <div
                    className="contact-card department-card flex-fill"
                    onMouseEnter={() => setHoveredCard(`dept-${contact.id}`)}
                    onMouseLeave={() => setHoveredCard(null)}
                    style={{ animationDelay: `${index * 0.1}s` }}
                  >
                    <div className="contact-card-content text-center p-2 h-100 d-flex flex-column justify-content-between">
                      <div
                        className="icon-container"
                        style={{ background: contact.gradient }}
                      >
                        <span className="icon-emoji">{contact.icon}</span>
                        <div className="pulse-ring"></div>
                      </div>

                      <h6 className="card-title mb-2">{contact.title}</h6>
                      <p className="card-description text-muted">
                        {contact.description}
                      </p>

                      <div className="email-container">
                        <a
                          href={`mailto:${contact.email}`}
                          className="email text-success"
                          title={contact.email}
                        >
                          {contact.email}
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>

            {/* Team Members */}
            <div className="row g-2 g-md-2 justify-content-center">
              <div className="col-12 text-center mb-1 mb-md-3">
                <div className="divider mx-auto"></div>
              </div>

              {teamMembers.map((member, index) => (
                <div
                  key={member.id}
                  className="col-12 col-sm-6 col-lg-4 d-flex"
                >
                  <div
                    className="contact-card team-card flex-fill"
                    onMouseEnter={() => setHoveredCard(`team-${member.id}`)}
                    onMouseLeave={() => setHoveredCard(null)}
                    style={{ animationDelay: `${(index + 3) * 0.1}s` }}
                  >
                    <div className="card-content text-center p-2 h-100 d-flex flex-column justify-content-between">
                      <div
                        className="avatar-container"
                        style={{ background: member.gradient }}
                      >
                        <span className="avatar-text">{member.avatar}</span>
                        <div className="avatar-ring"></div>
                      </div>

                      <h4 className="member-name mb-2">{member.name}</h4>

                      <div className="contact-info d-flex flex-column gap-1 w-100">
                        <div className="email-container">
                          <a
                            href={`mailto:${member.email}`}
                            className="email text-success"
                          >
                            {member.email}
                          </a>
                        </div>
                        {member.phone && (
                        <div className="email-container">
                          <a
                            href={`tel:${member.phone}`}
                            className="email text-dark"
                          >
                            {member.phone}
                          </a>
                        </div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default BuildingKnowledgeCommunity;
